import { render, staticRenderFns } from "./NormalSearchNav434.vue?vue&type=template&id=54934ec0&scoped=true&"
import script from "./NormalSearchNav434.vue?vue&type=script&lang=js&"
export * from "./NormalSearchNav434.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54934ec0",
  null
  
)

export default component.exports